import { z } from "zod";
/**
 * PATCH de campos geridos pela plataforma / híbridos (FASE-06-T28).
 * `.strict()` rejeita campos ERP (ex.: fullName) já na validação.
 */
export const patchEmployeeSchema = z
    .object({
    expectedVersion: z.number().int().positive(),
    displayName: z.string().trim().min(1).max(120).nullable().optional(),
    internalNotes: z.string().trim().max(4000).nullable().optional(),
    /** HÍBRIDO: só aceito na API se o e-mail ainda não veio do ERP. */
    email: z.union([z.string().trim().email().max(320), z.null()]).optional(),
})
    .strict()
    .refine((body) => body.displayName !== undefined ||
    body.internalNotes !== undefined ||
    body.email !== undefined, {
    message: "Informe ao menos um campo editável (displayName, internalNotes ou email)",
});
//# sourceMappingURL=patch-employee.js.map